// extracted by mini-css-extract-plugin
module.exports = {"mask":"Mask_mask__28RJo","spin":"Mask_spin__3Ychs"};